import { h, eraLabel } from "../ui.js";
import { pixelMark, type App } from "../main.js";
import { newsFeed } from "./news.js";
import { shell } from "../shell.js";
import { api } from "../api.js";

/** Launcher stack layout for the 640×400 window (platform spec §5). */
export function launcherView(app: App, _path: string): HTMLElement {
  const p = app.me.profile!;
  return h("div", { class: "frame" },
    h("div", { class: "titlebar" },
      h("span", { class: "logo", style: "font-size:12px" }, pixelMark(), "Bit Depth"),
      h("div", { class: "win" },
        h("button", { title: "Minimize", onclick: () => shell.minimize() }, "_"),
        h("button", { class: "close", title: "Close", onclick: () => shell.close() }, "×"),
      ),
    ),
    h("div", { class: "launcher-stack" },
      h("div", { class: "head" },
        h("div", {}, h("strong", {}, p.handle), " ", h("span", { class: "badge" }, eraLabel(p.era_id))),
        h("button", { class: "btn", style: "min-height:28px;font-size:10px", onclick: async () => { await api.logout(); app.go("/"); } }, "Sign out"),
      ),
      h("div", { class: "news-scroll" }, newsFeed(8)),
      h("div", { class: "play" },
        h("button", { class: "btn primary", onclick: () => shell.play(app.build) }, h("span", {}, "▶ Play"), h("small", { class: "mono-num" }, "build ", h("b", {}, app.build), ` · ${app.channel}`)),
      ),
    ),
  );
}
